import {
  GET_USER_DETAILS_BY_USER_ID_LOADING,
  GET_USER_DETAILS_BY_USER_ID_SUCCESS,
  GET_USER_DETAILS_BY_USER_ID_FAILURE,
} from "redux/types";

const initialState = {
  getUserDetailsLoading: false,
  userDetailsData: null,
  errors: null,
};

export const getUserProfileDetailsReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_USER_DETAILS_BY_USER_ID_LOADING:
      return { ...state, getUserDetailsLoading: action.payload };
    case GET_USER_DETAILS_BY_USER_ID_SUCCESS:
      return { ...state, userDetailsData: action.payload };
    case GET_USER_DETAILS_BY_USER_ID_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
